import styled from "styled-components";

const Wrapper = styled.div`
  height: 100%;
  max-height: 100%;
  width: calc(100vw);
  padding: 24px 48px;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`;

const ModalWrapper = ({ children, className }) => {
  return (
    <Wrapper className={`flexRow ${className  }`}>{children}</Wrapper>
  );
};

export default ModalWrapper;
